import { backendService } from "services"

export const getProcesses = async (tenant) => {
  return await backendService.get(`/mapping/process?companyKey=${tenant}`)
}

export const getProcessesPaged = async (tenant, page, perPage) => {
  return await backendService.get(`/mapping/process/paged?companyKey=${tenant}&page=${page}&perPage=${perPage}`)
}

export const getProcessesShort = async (tenant) => {
  return await backendService.get(`/mapping/process/short-data?companyKey=${tenant}`)
}

export const getProcessesShortPaged = async (tenant, page, perPage, queryContent) => {
  return await backendService.get(`/mapping/process/short-data-paged?companyKey=${tenant}&page=${page}&perPage=${perPage}${queryContent}`)
}

export const getProcessesNames = async (tenant) => {
  return await backendService.get(`/mapping/process/names?companyKey=${tenant}`)
}

export const getProcessById = async (id) => {
  return await backendService.get(`/mapping/process/${id}`)
}

export const getProcessMappingByIdAndMappingId = async (id, processMappingId) => {
  return await backendService.get(`/mapping/process/${id}/mapping/${processMappingId}`)
}

export const getProcessBoundsById = async (id) => {
  return await backendService.get(`/mapping/process/${id}/bounds`)
}

export const addProcess = async (process) => {
  return await backendService.post('/mapping/process', process)
}

export const editProcess = async (id, process) => {
  return await backendService.put(`/mapping/process/${id}`, process)
}

export const addProcessDataMapping = async (id, processDataMapping) => {
  return await backendService.post(`/mapping/process/${id}/mapping`, processDataMapping)
}

export const editProcessDataMapping = async (id, dataMappingId, processDataMapping) => {
  return await backendService.put(`/mapping/process/${id}/mapping/${dataMappingId}`, processDataMapping)
}

export const importProcessDataMapping = async (id, content) => {
  return await backendService.post(`/mapping/process/${id}/import-mapping`, content)
}

export const deleteProcess = async (processId) => {
  return await backendService.delete(`/mapping/process/${processId}`)
}

export const deleteProcessMapping = async (processId, processMappingId) => {
  return await backendService.delete(`/mapping/process/${processId}/mapping/${processMappingId}`)
}

export const archiveProcess = async (processId) => {
  return await backendService.post(`/mapping/process/${processId}/archive`)
}
export const unarchiveProcess = async (processId) => {
  return await backendService.post(`/mapping/process/${processId}/unarchive`)
}